import isMobilePhone from 'validator/es/lib/isMobilePhone';

/**
 * Phone number utility functions
 */

/**
 * Masks a phone number for display (shows first 2 and last 3 digits)
 * @param phone - The phone number to mask (can include country code)
 * @returns Masked phone number string (e.g., "+91 98***** **765")
 */
export const getMaskedPhoneNumber = (phone: string): string => {
  const cleanPhone = phone.replace('+', '');

  let extractedCountryCode = '';
  let number = cleanPhone;

  if (cleanPhone.startsWith('91')) {
    extractedCountryCode = '91';
    number = cleanPhone.slice(2);
  } else if (cleanPhone.startsWith('1')) {
    extractedCountryCode = '1';
    number = cleanPhone.slice(1);
  } else {
    extractedCountryCode = cleanPhone.slice(0, 2);
    number = cleanPhone.slice(2);
  }

  const lastDigits = number.slice(-3);
  const firstDigits = number.slice(0, 2);
  const maskedMiddle = '*'.repeat(Math.max(0, number.length - 5));

  return `+${extractedCountryCode} ${firstDigits}${maskedMiddle} **${lastDigits}`;
};

/**
 * Validates phone number using validator library
 * @param phone - Full phone number with country code
 * @param locale - Locale for validation (e.g., 'en-IN')
 * @returns boolean indicating if phone is valid
 */
export const validatePhone = (phone: string, locale: string): boolean => {
  return isMobilePhone(phone, locale as any);
};

/**
 * Format phone number for display with spaces
 * @param phone - Phone number string
 * @returns Formatted phone number
 */
export const formatPhoneNumber = (phone: string): string => {
  // Format as "98765 43210" for 10 digit numbers
  if (phone.length === 10) {
    return `${phone.slice(0, 5)} ${phone.slice(5)}`;
  }
  return phone;
};
